import matter from 'gray-matter';
import { readingTime } from 'reading-time-estimator';
const files = ['post-1.md', 'post-2.md', 'post-3.md'];

export async function fetchPosts() {
  const posts = await Promise.all(
    files.map(async (file) => {
      const res = await fetch(`/posts/${file}`);
      const text = await res.text();
      const { data, content } = matter(text);
      const readTime = readingTime(content, 320, 'es').minutes;
      const formattedCreated = formattedDate(data.created);
      return { ...data, content, file, readTime, formattedCreated };
    })
  );
  return posts.sort((a, b) => Date(a.created) - Date(b.created));
}

export async function fetchPostBySlug(slug) {
  const posts = await fetchPosts();
  return posts.find((post) => post.slug === slug);
}

function formattedDate(rawDate) {
  const [day, month, year] = rawDate.split("-");
  const date = new Date(`${year}-${month}-${day}`);

  const monthName = date.toLocaleString("es-ES", { month: "long" });
  const capitalizedMonth = monthName.charAt(0).toUpperCase() + monthName.slice(1);

  return `${day} ${capitalizedMonth} ${year}`;
}